<!-- <div class="page-content page-fill"> -->
<!-- <div *ngIf="!showAsDialog">
<button type="button" (click)="viewSchedule()" class="btn btn-secondary m-1" [disabled]="true">Print Giving Cause Sheet</button>
</div>
<div *ngIf="showAsDialog">
  <button type="button" (click)="closeDialog()" class="btn btn-secondary mb-2">Close</button>
</div> -->
<!-- <div class="grid-fill date-scheduler" style="max-width: 1600px"> -->
<dx-scheduler
  #scheduler
  id="scheduler"
  class="date-scheduler"
  [dataSource]="schedulerData"
  [views]="showAsDialog ? ['month'] : ['month', 'year']"
  [currentView]="'month'"
  [currentDate]="currentDate"
  [firstDayOfWeek]="0"
  [startDayHour]="0"
  [endDayHour]="24"
  [showAllDayPanel]="true"
  [allDayExpr]="'allDay'"
  [editing]="false"
  (onAppointmentClick)="toolTip($event)"
  (onAppointmentRendered)="setBackGroundColor($event)"
  (onCellContextMenu)="onCellContextMenu($event)"
  (onAppointmentContextMenu)="onAppointmentContextMenu($event)"
  (onContentReady)="onContentReady($event)"
  [appointmentTemplate]="!showAsDialog ? 'appointment-template' : ''"
  appointmentTooltipTemplate="tooltip-template"
  >
  <div *dxTemplate="let model of 'appointment-template'">
    @if (model?.appointmentData?.name) {
      <div>
        <div>
          <div>{{ model?.appointmentData?.name }}</div>
          <!-- <div>{{ model?.appointmentData?.aMOffering ? 'AM - ' : 'PM - ' }}{{ model?.appointmentData?.name }} {{model?.appointmentData?.amount ? ' - $' + model?.appointmentData?.amount.toFixed(2) : ''}}</div> -->
        </div>
      </div>
    }
  </div>

  <div *dxTemplate="let data of 'tooltip-template'">
    <div class="dx-scheduler-tooltip" [ngStyle]="{color: data.appointmentData.color}">
      <div>{{ data.appointmentData.name }}</div>
    </div>
  </div>

  <dxi-view name="Month" type="month" [intervalCount]="1"> </dxi-view>
  <dxi-view name="Year" type="month" [intervalCount]="12"> </dxi-view>
</dx-scheduler>
<dx-context-menu
  #appointmentMenu
  [dataSource]="appointmentContextMenuItems"
  target=".dx-scheduler-appointment"
  (onItemClick)="onContextMenuItemClick($event)"
  [width]="325"
></dx-context-menu>
<dx-context-menu #cellMenu [dataSource]="cellContextMenuItems" target=".dx-scheduler-date-table-cell" (onItemClick)="onContextMenuItemClick($event)" [width]="200">
</dx-context-menu>
<!-- </div> -->
<!-- </div> -->
